import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';

import { environment } from '../../../environments/environment';

const API_BASE_PATH = '/api/v1';

export abstract class Api {
  protected readonly http: HttpClient = inject(HttpClient);

  protected readonly apiUrl: string = `${environment.apiUrl}${API_BASE_PATH}`;
}
